import 'css-chunksrc/client/scenes/calendar/filters/dataTypeFilter/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_1a8ny_1",
  "input": "_input_1a8ny_7",
  "toggleArrow": "_toggleArrow_1a8ny_23",
  "selectedDataTypes": "_selectedDataTypes_1a8ny_31",
  "placeholder": "_placeholder_1a8ny_40",
  "list": "_list_1a8ny_45",
  "item": "_item_1a8ny_57",
  "typeName": "_typeName_1a8ny_70",
  "opened": "_opened_1a8ny_77"
};